import { CommonModule, isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'full-team-official-signature',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './full-team-official-signature.component.html',
  styleUrl: './full-team-official-signature.component.css'
})
export class FullTeamOfficialSignatureComponent implements OnInit, OnChanges {
  
  @Input() fullTeamAssessmentData: any;
  @Output() onSaveSection17 = new EventEmitter<any>();

  currentDate = new Date();
  fullTeamSignatureForm: FormGroup = new FormGroup([]);

  constructor(
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fullTeamAssessmentData'] && this.fullTeamAssessmentData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.fullTeamSignatureForm = new FormGroup({
      user_signature_name: new FormControl(this.fullTeamAssessmentData?.user_signature_name || '', Validators.required),
    });
  }

  saveFullTeamSignature(): void {
    if (this.fullTeamSignatureForm.valid) {
        this.onSaveSection17.emit(this.fullTeamSignatureForm.value);
    }
  }

}
